import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AOS from 'aos';
import 'aos/dist/aos.css';

/* 🔧 Suppress ResizeObserver warning (Elfsight issue) */
const resizeObserverError = "ResizeObserver loop completed with undelivered notifications";

const originalError = console.error;
console.error = (...args) => {
  if (args[0] && args[0].toString().includes(resizeObserverError)) {
    return;
  }
  originalError(...args);
};

window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

/* 🚀 Root Component */
function Root() {
  useEffect(() => {
    AOS.init({
      disable: () => window.innerWidth < 769,
    });
  }, []);

  return <App />;
}

/* 🔥 Render App */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Root />
);

reportWebVitals();